import { DeleteOutlined, SettingOutlined } from '@ant-design/icons';
import { Button, message, Space } from 'antd';
import * as Component from 'components';
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { peopleApiService } from 'service/api/peopleApiService';
import { PeopleInterface } from 'type/peopleType';
import { CastData } from '../../../../shared/types/i18n/i18nTypes';

export default function People(): React.JSX.Element {
  const navigate = useNavigate();
  const [searchTerm] = React.useState<string>('');
  const [refreshCounter, setRefreshCounter] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();

  const columns = [
    {
      title: 'THUMBNAIL',
      dataIndex: 'thumbnail',
      key: 'thumbnail',
      width: '10%',
      render: (_text: string, record: PeopleInterface | CastData): JSX.Element => (
        <img
          src={record.thumbnail || ''}
          alt=""
          className="people-thumbnail"
          style={{ width: '80%', height: 'auto' }}
        />
      ),
    },
    {
      title: <div>NAME</div>,
      dataIndex: 'name',
      key: 'name',
      sorter: (a: PeopleInterface | CastData, b: PeopleInterface | CastData): number =>
        a.name.localeCompare(b.name),
      render: (_text: string, record: PeopleInterface | CastData): JSX.Element => (
        <div>{record.name_en}</div>
      ),
    },
    {
      title: 'TYPE',
      dataIndex: 'type',
      sorter: (a: PeopleInterface, b: PeopleInterface): number =>
        (a.type || '').localeCompare(b.type || ''),
      key: 'type',
    },
    {
      title: 'BIRTHDATE',
      dataIndex: 'birthdate',
      key: 'birthdate',
    },
    {
      title: 'NATIONALITY',
      dataIndex: 'nationality',
      key: 'nationality',
    },
    {
      title: 'ACTIONS',
      key: 'actions',
      dataIndex: 'actions',
      render: (_text: string, record: PeopleInterface): JSX.Element => (
        <Space>
          <Button
            icon={<SettingOutlined />}
            onClick={() => navigate(`/people/edit/${record.id}`)}
            className="action-btn"
          />
          <Button
            icon={<DeleteOutlined />}
            onClick={() => {
              message.info('You do not have permission');
            }}
            className="action-btn delete-btn"
          />
        </Space>
      ),
    },
  ];

  const fetchPeopleTableData = useCallback(
    async (
      params: URLSearchParams
    ): Promise<{ data: (PeopleInterface | CastData)[]; count: number }> => {
      const peopleList = await peopleApiService.fetch(params);
      return { data: peopleList.results, count: peopleList.count };
    },
    [searchTerm]
  );

  useEffect(() => {
    setRefreshCounter(prev => prev + 1);
  }, [searchTerm]);

  return (
    <Component.BasePageComponent>
      <Component.TableComponent<PeopleInterface | CastData>
        key={refreshCounter}
        name="People"
        searchParams={searchParams}
        setSearchParams={setSearchParams}
        dataFetch={fetchPeopleTableData}
        actions={{
          onAddClick: () => {
            navigate('/people/add');
          },
        }}
        columns={columns}
      />
    </Component.BasePageComponent>
  );
}
